module.exports = __webpack_public_path__ + "img/hover_icon_catalogo_materiales_y_equipos.30b52843.svg";